import React, { memo, useEffect, useState } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot, ReportType } from '../../../models';
import { REPORT_CURRENCIES } from '../../../constants';
import {
  getReportSettingField,
  getReportypeSetting,
} from '../../find-report/report-setting';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { fetchReportTypeSettingWithCache } from '../../../api';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

const getViewByText = (
  reportSnapshot: ReportSnapshot,
  reportTypeSetting: ReportTypeSetting,
): string => {
  if (!reportSnapshot.includedFields || !reportSnapshot.includedFields.length)
    return '';
    const includedFields = reportSnapshot.includedFields.filter(
      (f) =>
        f.reportPossibleField.isAllocation || f.reportPossibleField.isDimension
  )[0];
  if (!includedFields) return '';
  const includedStructureId = includedFields.reportPossibleField?.id;
  const { allocationItemId, dimensionItemId } = includedFields.reportMustHaveFieldFilters[0];

  const reportSetting = getReportypeSetting(
    reportTypeSetting,
    ReportType.effectOfStandardAdoptionPAndL,
  );
  const viewByField = getReportSettingField(reportSetting, 'ViewByOptions');
  const viewByValue = viewByField.reportSettingFieldValues.find(
    (fieldValue) => fieldValue.value === `${includedStructureId}`,
  );
  if (!viewByValue) return '';

  const subViewByField = getReportSettingField(
    reportSetting,
    'ViewByItemOptions',
  );
  const subViewByValue = subViewByField.reportSettingFieldValues.find(
    (fieldValue) =>
      fieldValue.value === `${allocationItemId || dimensionItemId}` &&
      fieldValue.parrentId === includedStructureId,
  );

  return `${viewByValue.name}${
    subViewByValue ? ` - ${subViewByValue.name}` : ''
  }`;
};

function ReportSettingPAndL({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const { currency } = reportSnapshot;
  const [viewByText, setViewByText] = useState('');

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const reportTypeSetting = await fetchReportTypeSettingWithCache(
        reportSnapshot.clientId,
      );
      const builtViewByText = getViewByText(reportSnapshot, reportTypeSetting);
      setViewByText(builtViewByText);
    };
    loadData();
  }, [reportSnapshot, setViewByText]);

  return (
    <>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <Styled.ReportSettingItem>
        <Icon name="gear" />
        <GStyled.Text>View By</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {viewByText || 'Total Organization'}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingPAndL);
